/**
 * EGA Favorites — heart button + retail favorites
 *
 * Retail / logged-out: heart toggles a favorite in localStorage (and syncs to
 *   the Worker when logged in). The favorites page renders a simple grid.
 *
 * Trade (window.EGA_IS_TRADE === true): heart opens the projects save modal
 *   defined in ega-projects.js. This file does not render any project UI.
 *
 * API base is shared with the projects system.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ega_favorites';
  var ANALYTICS_KEY = 'ega_fav_events';
  var API_BASE = 'https://ega-favorites.dinobravo.workers.dev';
  window.EGA_FAV_API_BASE = API_BASE;

  var favorites = loadFavorites();
  var toastTimeout = null;
  var _customerId = null;
  var _synced = false;
  var retailRenderTimer = null;

  function loadFavorites() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveFavorites() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites)); } catch (e) {}
  }

  function isFavorited(handle) { return favorites.indexOf(handle) !== -1; }

  function isTrade() {
    if (window.EGA_IS_TRADE) return true;
    if (document.querySelector('.ega-fav-header-link--trade')) return true;
    if (document.body && document.body.getAttribute('data-ega-trade') === 'true') return true;
    return false;
  }

  if (!window.EGA_IS_TRADE && isTrade()) window.EGA_IS_TRADE = true;

  function getCustomerId() {
    if (_customerId) return _customerId;
    if (window.__st && window.__st.cid) { _customerId = String(window.__st.cid); return _customerId; }
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
      var cid = window.ShopifyAnalytics.meta.page.customerId;
      if (cid) { _customerId = String(cid); return _customerId; }
    }
    var metaEl = document.querySelector('meta[name="customer-id"]');
    if (metaEl && metaEl.content) { _customerId = metaEl.content; return _customerId; }
    return null;
  }
  window.EGA_GET_CUSTOMER_ID = getCustomerId;

  function isLoggedIn() { return !!getCustomerId(); }

  function apiFetch(path, options) {
    options = options || {};
    options.headers = options.headers || {};
    var cid = getCustomerId();
    if (cid) options.headers['X-Customer-Id'] = cid;
    return fetch(API_BASE + path, options);
  }
  window.EGA_API_FETCH = apiFetch;

  function logEvent(handle, action, source) {
    try {
      var events = JSON.parse(localStorage.getItem(ANALYTICS_KEY) || '[]');
      events.push({ h: handle, a: action, s: source, t: Date.now() });
      if (events.length > 500) events = events.slice(-500);
      localStorage.setItem(ANALYTICS_KEY, JSON.stringify(events));
    } catch (e) {}
  }

  function showToast(message) {
    var toast = document.getElementById('ega-fav-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'ega-fav-toast';
      toast.className = 'ega-fav-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    if (toastTimeout) clearTimeout(toastTimeout);
    toastTimeout = setTimeout(function () { toast.classList.remove('show'); }, 2000);
  }
  window.EGA_SHOW_TOAST = showToast;

  function updateHeaderBadge() {
    var count = isTrade() && window.EGA_PROJECTS
      ? window.EGA_PROJECTS.savedHandleCount()
      : favorites.length;
    document.querySelectorAll('.ega-fav-badge').forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('.ega-fav-header-link').forEach(function (l) {
      if (count > 0) l.classList.add('has-favs'); else l.classList.remove('has-favs');
    });
  }
  window.EGA_UPDATE_HEADER_BADGE = updateHeaderBadge;

  function retailToggle(handle, source) {
    var i = favorites.indexOf(handle);
    var added;
    if (i === -1) { favorites.push(handle); added = true; }
    else { favorites.splice(i, 1); added = false; }
    saveFavorites();
    updateAllButtons(handle);
    updateHeaderBadge();
    showToast(added ? 'Added to Favorites' : 'Removed from Favorites');
    logEvent(handle, added ? 'add' : 'remove', source || 'collection');
    if (isLoggedIn()) {
      apiFetch('/api/fav', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ handle: handle, source: source })
      }).catch(function () {});
    }
    return added;
  }

  function updateAllButtons(handle) {
    var saved = isTrade() && window.EGA_PROJECTS
      ? window.EGA_PROJECTS.isHandleSaved(handle)
      : isFavorited(handle);
    document.querySelectorAll('.ega-fav-btn[data-handle="' + cssEscape(handle) + '"]').forEach(function (btn) {
      var label = btn.parentNode && btn.parentNode.querySelector('.ega-fav-pdp-label');
      if (saved) {
        btn.classList.add('is-fav');
        btn.classList.add('ega-fav-pop');
        btn.setAttribute('aria-label', isTrade() ? 'Manage in projects' : 'Remove from favorites');
        if (label) label.textContent = isTrade() ? 'Saved to Projects' : 'Saved to Favorites';
      } else {
        btn.classList.remove('is-fav');
        btn.setAttribute('aria-label', isTrade() ? 'Save to a project' : 'Add to favorites');
        if (label) label.textContent = isTrade() ? 'Save to Project' : 'Add to Favorites';
      }
    });
    setTimeout(function () {
      document.querySelectorAll('.ega-fav-btn[data-handle="' + cssEscape(handle) + '"]').forEach(function (b) {
        b.classList.remove('ega-fav-pop');
      });
    }, 400);
  }
  window.EGA_UPDATE_BUTTONS = updateAllButtons;

  function cssEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/["\\]/g, '\\$&');
  }

  function handleCardHeart(handle, source, btn) {
    if (isTrade()) {
      if (window.EGA_PROJECTS && typeof window.EGA_PROJECTS.openSaveModal === 'function') {
        window.EGA_PROJECTS.openSaveModal(handle, source);
      } else {
        showToast('Projects module loading…');
      }
      return;
    }
    retailToggle(handle, source);
  }

  function sharedToggle(handle, source) {
    if (isTrade()) {
      if (window.EGA_PROJECTS && typeof window.EGA_PROJECTS.openSaveModal === 'function') {
        window.EGA_PROJECTS.openSaveModal(handle, source || 'collection');
        return true;
      }
      showToast('Projects module loading…');
      return false;
    }
    return retailToggle(handle, source);
  }

  function sharedIsSaved(handle) {
    return isTrade() && window.EGA_PROJECTS
      ? window.EGA_PROJECTS.isHandleSaved(handle)
      : isFavorited(handle);
  }

  function createHeartButton(handle, source) {
    var btn = document.createElement('button');
    var saved = isTrade() && window.EGA_PROJECTS
      ? window.EGA_PROJECTS.isHandleSaved(handle)
      : isFavorited(handle);
    btn.className = 'ega-fav-btn' + (saved ? ' is-fav' : '');
    btn.setAttribute('aria-label', saved
      ? (isTrade() ? 'Manage in projects' : 'Remove from favorites')
      : (isTrade() ? 'Save to a project' : 'Add to favorites'));
    btn.setAttribute('data-handle', handle);
    btn.setAttribute('data-source', source || 'collection');
    btn.innerHTML = '<svg class="ega-fav-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      handleCardHeart(handle, btn.getAttribute('data-source'), btn);
    });
    return btn;
  }
  window.EGA_CREATE_HEART = createHeartButton;

  function processNewCards(container) {
    var cards = container.querySelectorAll('.ega-cf-card, .product-card, [data-product-handle]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.ega-fav-btn')) continue;
      var handle = card.getAttribute('data-product-handle');
      if (!handle) {
        var link = card.querySelector('a[href*="/products/"]');
        if (link) {
          var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
          if (match) handle = match[1];
        }
      }
      if (!handle) continue;
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      card.appendChild(createHeartButton(handle, 'collection'));
    }
  }

  function injectIntoFilterCards() {
    var grid = document.getElementById('ega-cf-grid');
    document.querySelectorAll('.product-card, [data-product-handle]').forEach(function (card) {
      if (grid && grid.contains(card)) return;
      if (card.querySelector('.ega-fav-btn')) return;
      processNewCards(card.parentElement || document.body);
    });
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node.nodeType === 1) processNewCards(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function injectIntoPDP() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    var handle = match[1];
    var titleEl = document.querySelector('.ega-product-title, .product-title, .product__title, h1.title');
    var ctaArea = document.querySelector('.ega-pdp-cta, .ega-pdp .ega-cta, .product-form__buttons, .product-form, .product__info-wrapper');
    var target = ctaArea || titleEl;
    if (!target || document.querySelector('.ega-fav-pdp-wrapper')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'ega-fav-pdp-wrapper';
    var btn = createHeartButton(handle, 'pdp');
    btn.classList.add('ega-fav-pdp');
    var label = document.createElement('span');
    label.className = 'ega-fav-pdp-label';
    var saved = isTrade() && window.EGA_PROJECTS
      ? window.EGA_PROJECTS.isHandleSaved(handle)
      : isFavorited(handle);
    label.textContent = saved
      ? (isTrade() ? 'Saved to Projects' : 'Saved to Favorites')
      : (isTrade() ? 'Save to Project' : 'Add to Favorites');
    wrapper.appendChild(btn);
    wrapper.appendChild(label);

    if (ctaArea) ctaArea.parentNode.insertBefore(wrapper, ctaArea);
    else titleEl.parentNode.insertBefore(wrapper, titleEl.nextSibling);
  }

  // ── Retail favorites page (simple grid) ────────────────────────────────
  function buildFavCardHtml(p, handle) {
    var imgSrc = p && p.i ? String(p.i).replace(/(\.\w+)$/, '_400x500$1') : '';
    // EGA: $0 = MTO/custom; leave price slot empty rather than showing "Price on Request".
    var price = p && p.p > 0 ? '$' + (p.p / 100).toLocaleString() : '';
    var title = (p && p.t) || handle.replace(/-/g, ' ');
    return '<div class="ega-fav-card" data-product-handle="' + handle + '">' +
      '<div class="ega-fav-card-img"><a href="/products/' + handle + '">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(title) + '" loading="lazy">' : '') +
      '</a></div>' +
      '<div class="ega-fav-card-info">' +
      '<a href="/products/' + handle + '" class="ega-fav-card-title">' + escapeHtml(title) + '</a>' +
      '<div class="ega-fav-card-price">' + price + '</div>' +
      '<button class="ega-fav-remove" data-handle="' + handle + '">Remove</button>' +
      '</div></div>';
  }

  function renderRetailFavorites() {
    var container = document.getElementById('ega-favorites-container');
    if (!container) return;
    if (!favorites.length) {
      container.innerHTML = '<div class="ega-fav-empty">' +
        '<div class="ega-fav-empty-icon"><svg viewBox="0 0 24 24" width="48" height="48"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="none" stroke="#C9A46A" stroke-width="1.5"/></svg></div>' +
        '<h2>No favorites yet</h2><p>Tap the heart on any piece to save it here.</p>' +
        '<a href="/collections/all-collections" class="ega-fav-browse-btn">Browse Collections</a></div>';
      return;
    }
    var map = {};
    if (window.EGA_ALL_PRODUCTS && Array.isArray(window.EGA_ALL_PRODUCTS)) {
      window.EGA_ALL_PRODUCTS.forEach(function (p) { map[p.h] = p; });
    }
    var html = '<div class="ega-fav-header"><h1>My Favorites</h1>' +
      '<span class="ega-fav-count">' + favorites.length + ' item' + (favorites.length !== 1 ? 's' : '') + '</span></div>' +
      '<div class="ega-fav-grid">';
    favorites.forEach(function (h) { html += buildFavCardHtml(map[h], h); });
    html += '</div>';
    container.innerHTML = html;
    container.querySelectorAll('.ega-fav-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        retailToggle(btn.getAttribute('data-handle'), 'favorites-page');
        renderRetailFavorites();
      });
    });
  }

  function scheduleRetailRender() {
    if (isTrade()) return;
    if (retailRenderTimer) clearTimeout(retailRenderTimer);

    var attempts = 0;
    function tick() {
      renderRetailFavorites();
      if (window.EGA_ALL_PRODUCTS && Array.isArray(window.EGA_ALL_PRODUCTS) && window.EGA_ALL_PRODUCTS.length) return;
      if (attempts >= 20) return;
      attempts += 1;
      retailRenderTimer = setTimeout(tick, 250);
    }

    tick();
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  window.EGA_ESCAPE_HTML = escapeHtml;

  function syncRetailFavorites() {
    var cid = getCustomerId();
    if (!cid || _synced || isTrade()) return;
    _synced = true;
    apiFetch('/api/fav/sync', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ favorites: favorites })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && Array.isArray(data.favorites)) {
          favorites = data.favorites;
          saveFavorites();
          updateHeaderBadge();
          scheduleRetailRender();
          favorites.forEach(updateAllButtons);
        }
      })
      .catch(function () {});
  }

  function init() {
    updateHeaderBadge();
    injectIntoFilterCards();
    injectIntoPDP();
    if (!isTrade()) scheduleRetailRender();
    setTimeout(syncRetailFavorites, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.EGA_FAVORITES = {
    isFavorited: sharedIsSaved,
    getAll: function () { return favorites.slice(); },
    count: function () {
      return isTrade() && window.EGA_PROJECTS
        ? window.EGA_PROJECTS.savedHandleCount()
        : favorites.length;
    },
    toggle: sharedToggle,
    updateAllButtons: updateAllButtons,
    updateHeaderBadge: updateHeaderBadge
  };
})();
